import useReveal from "@/hooks/useReveal";

const CRAFT_IMAGE = "/craftsmanship/craft-1.jpg";

const TOOL_IMAGE = "/craftsmanship/craft-2.jpg";

const NOTES = [
  { label: "Fabric", value: "Italian wool blends, breathable linens, indigenous handlooms." },
  { label: "Embroidery", value: "Hand-finished motifs, tonal monograms, restrained ornament." },
  { label: "Trims", value: "Horn buttons, antique brass, hidden plackets, hand-stitched edges." },
  { label: "Fit", value: "Department-specific patterning, six-day comfort-tested." },
  { label: "Detailing", value: "Lapel rolls, pocket geometry, hidden brand notations." },
  { label: "Durability", value: "Industrial-wash certified for hospitality service cycles." },
];

function CraftNote({ n, delay }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`craft-${n.label.toLowerCase()}`}
      className={`reveal reveal-delay-${delay}`}
    >
      <div className="overline-muted mb-3">{n.label}</div>
      <p className="text-[15px] leading-relaxed text-espresso font-light">
        {n.value}
      </p>
    </div>
  );
}

export default function Craftsmanship() {
  const headRef = useReveal();
  return (
    <section
      data-testid="craftsmanship-section"
      className="relative py-28 md:py-40 bg-bone-200/70 border-y border-borderwarm overflow-hidden"
    >
      <div className="container-luxury grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div ref={headRef} className="reveal lg:col-span-5">
          <div className="overline mb-6">Craftsmanship</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[58px] leading-[1.06] text-espresso tracking-tight text-balance">
            <em className="italic text-oxblood">Tactile</em>, in every
            stitch and seam.
          </h2>
          <p className="mt-6 max-w-md text-espresso-soft text-[15px] md:text-base leading-relaxed font-light">
            We obsess over the small disciplines — fabric hand, lapel roll,
            seam allowance — because hospitality wears its uniforms hard.
          </p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 gap-6">
          <Reveal className="aspect-[3/4] overflow-hidden">
            <img src={CRAFT_IMAGE} alt="Trident hospitality uniform — silk saree programme" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal delay={2} className="aspect-[3/4] overflow-hidden mt-12">
            <img src={TOOL_IMAGE} alt="Burgundy double-breasted hospitality suit — Auraa tailoring" className="w-full h-full object-cover" />
          </Reveal>
        </div>
      </div>

      <div className="container-luxury mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10 border-t border-borderwarm pt-14">
        {NOTES.map((n, i) => (
          <CraftNote key={n.label} n={n} delay={(i % 4) + 1} />
        ))}
      </div>
    </section>
  );
}

function Reveal({ children, delay = 0, className = "" }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal reveal-delay-${delay} ${className}`}>
      {children}
    </div>
  );
}
